export default "__VITE_ASSET__bDT1qIt1__"